/* src/app/pto-policy/assignment-presenter/assignment-presenter.component.scss */
.cell-highlight {
  background-color: rgba(255, 243, 205, 0.8078431373);
}
.setting-checkbox {
  padding-left: 1vw;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-bottom: 0;
}
body#themeTag :host ::ng-deep .tabulator-header-filter {
  height: 2.1em;
}
body#themeTag :host ::ng-deep .p-multiselect.p-component {
  height: 2.1em !important;
}
/*# sourceMappingURL=assignment-presenter.component.css.map */
